module.exports = __webpack_public_path__ + "static/img/banner2.db0b9db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutOur/banner2.jpg
// module id = U11K
// module chunks = 1